var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaadinOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vaadin:office",
    clipPath: "url(#clip0_108_223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M61.5706 53.0852L51.4993 15.4989L41.2485 18.2456L38.5018 7.99474L7.74929 16.2348L20.5672 64.072L13.7333 65.9032L14.6489 69.3201L38.5675 62.9112L35.8208 52.6603L42.6547 50.8292L45.4014 61.08L69.32 54.6711L68.4044 51.2541L61.5706 53.0852ZM30.5727 46.742L23.7388 48.5731L21.9077 41.7393L28.7416 39.9081L30.5727 46.742ZM27.826 36.4912L20.9921 38.3223L19.161 31.4884L25.9949 29.6573L27.826 36.4912ZM25.0793 26.2403L18.2454 28.0715L16.4143 21.2376L23.2482 19.4065L25.0793 26.2403ZM40.8236 43.9953L33.9897 45.8264L32.1585 38.9926L38.9924 37.1614L40.8236 43.9953ZM38.0769 33.7445L31.243 35.5756L29.4118 28.7417L36.2457 26.9106L38.0769 33.7445ZM35.3302 23.4936L28.4963 25.3248L26.6651 18.4909L33.499 16.6598L35.3302 23.4936ZM54.4913 40.333L47.6574 42.1642L45.8263 35.3303L52.6602 33.4992L54.4913 40.333ZM51.7446 30.0822L44.9107 31.9133L43.0796 25.0795L49.9135 23.2483L51.7446 30.0822Z",
    fill: "#87CBC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.5997,
    height: 56.5997,
    fill: "white",
    transform: "translate(-0.00012207 14.649) rotate(-15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaadinOffice);
export default __webpack_public_path__ + "static/media/vaadin_office.a1d66024155209b0c8923908b4552395.svg";
export { ForwardRef as ReactComponent };